import React from "react";
import { Card, Col, Flex, Form, Input, Row, Switch } from "antd";
import "react-phone-number-input/style.css";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import { css } from "@emotion/css";
import TrashIcon from "../../../../../../../../Theme/CustomIcons/Icons/Essetional/TrashIcon";
import { useSelector } from "react-redux";

export const PointOfContactCard = ({ form }) => {
  const themeDefault = useSelector((state) => state.themeDefault);

  return (
    <Card
      bordered
      title={
        <div
          style={{
            borderBottom: themeDefault?.info?.newConfig?.cardborder,
            paddingBottom: 8,
          }}
        >
          Point of Contact
        </div>
      }
      extra={
        <span
          style={{ textDecoration: "underline", cursor: "pointer" }}
          onClick={() =>
            form.setFieldsValue({
              pointOfContacts: [
                ...(form.getFieldValue("pointOfContacts") || []),
                {},
              ],
            })
          }
        >
          Add Point of Contact
        </span>
      }
    >
      <Form.List name="pointOfContacts" initialValue={[{}]}>
        {(fields, { remove }) => (
          <Row gutter={[8, 8]}>
            {fields.map(({ key, name, ...rest }) => (
              <Col span={8} key={key}>
                <Card
                  title={
                    <Flex align="center" gap={8}>
                      <Form.Item
                        name={[name, "isPrimary"]}
                        valuePropName="checked"
                        style={{ marginBottom: 8 }}
                      >
                        <Switch />
                      </Form.Item>
                      Make Primary POC
                    </Flex>
                  }
                  extra={
                    <TrashIcon
                      onClick={() => remove(name)}
                      style={{ cursor: "pointer" }}
                    />
                  }
                >
                  <Flex gap={8} wrap="wrap" style={{ width: "100%" }}>
                    <Form.Item
                      {...rest}
                      name={[name, "firstName"]}
                      label="First Name"
                      style={{ flex: 1, minWidth: "250px", marginBottom: 8 }}
                    >
                      <Input placeholder="Enter First Name" />
                    </Form.Item>

                    <Form.Item
                      {...rest}
                      name={[name, "lastName"]}
                      label="Last Name"
                      style={{ flex: 1, minWidth: "250px", marginBottom: 8 }}
                    >
                      <Input placeholder="Enter Last Name" />
                    </Form.Item>

                    <Form.Item
                      {...rest}
                      name={[name, "workEmail"]}
                      label="Work Email"
                      style={{ width: "100%", marginBottom: 8 }}
                      rules={[
                        {
                          type: "email",
                          message: "Please enter a valid email address",
                        },
                      ]}
                    >
                      <Input placeholder="Enter Work Email" />
                    </Form.Item>

                    <Form.Item
                      {...rest}
                      name={[name, "phone"]}
                      label="Phone Number"
                      style={{ width: "100%", marginBottom: 8 }}
                      className={css`
                        .PhoneInputInput {
                          padding-left: 12px;
                        }
                      `}
                    >
                      <PhoneInputWithCountrySelect
                        placeholder="Enter phone number"
                        international
                        defaultCountry="AE"
                      />
                    </Form.Item>
                  </Flex>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </Form.List>
    </Card>
  );
};
